module.exports = __webpack_public_path__ + "media/images/logo-929967bf9adcb43311291af78a5290d3.png";